import React from 'react';
import { WelcomeModal } from './WelcomeModal';
import { useWelcomeModal } from './useWelcomeModal';

/** Connects the welcome modal to the homepage. */
export const HomeWelcomeModal = () => {
  const { isOpen, firstName, options, practicalSupport, complete, dismiss } =
    useWelcomeModal();

  if (!isOpen) {
    return null;
  }

  return (
    <WelcomeModal
      open
      entryPoint="onboarding-flow"
      options={options}
      firstName={firstName}
      practicalSupport={practicalSupport}
      onComplete={complete}
      onDismiss={dismiss}
    />
  );
};
